import React from 'react';
import {
  Container,
  ContainerProps,
  styled,
  useTheme,
} from '@vw-marketing/us-components';
import { applyCustomStylesToChildren } from '../utils';

interface ContainerBoxProps extends ContainerProps {
  style?: React.CSSProperties;
  component?: keyof JSX.IntrinsicElements;
  className?: string;
  [key: string]: any;
}

const StyledWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$customStyles',
})<{ $customStyles?: React.CSSProperties }>`
  ${({ $customStyles }) => applyCustomStylesToChildren($customStyles)}
`;

export const ContainerBox = React.forwardRef<HTMLDivElement, ContainerBoxProps>(
  ({ children, style, ...rest }, ref) => {
    const theme = useTheme();
    const resolvedStyle = typeof style === 'function' ? style(theme) : style;

    return (
      <StyledWrapper ref={ref} $customStyles={resolvedStyle}>
        <Container {...rest}>{children}</Container>
      </StyledWrapper>
    );
  }
);

ContainerBox.displayName = 'ContainerBox';
